import {
	API_ERROR,
	SR_PURCHASE_ORDER_LIST,
	SR_PURCHASE_ORDER_LIST_SUCCESS,
	SR_TOGGLE_ITEM_MENU,
	SR_SET_PARAMS,
	FILTER_INPUT_SR_CHANGEVALUE,
	FILTER_SELECT_SR_CHANGEVALUE,
	SR_PURCHASE_ORDER_ROW_DATA,
	SR_PURCHASE_ORDER_ROW_DATA_SUCCESS,
	SR_LIST_LAYOUT,
	FILTERS_SHOW_SRQ_RIGHT_SIDEBAR,
	FILTERS_HIDE_SR_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	SR_PDF_DOWNNLOAD,
	MR_SR_CODE_DETAILS,
	MR_SR_CODE_DETAILS_SUCCESS,
	PI_SR_CODE_DETAILS,
	PI_SR_CODE_DETAILS_SUCCESS,
	SR_PO_ITEM_ACKNOWLEDGE_OPEN,
	SR_PO_ITEM_ACKNOWLEDGE_CLOSE,
	SR_PO_ITEM_INPUT_SR_CHANGEVALUE,
	SR_PO_ITEM_ACKNOWLEDGE,
	SR_PURCHASE_ORDER_CLOSE,
	SR_PURCHASE_ORDER_FOUCS_POST,
	PO_CLOSE_SR_MODAL_OPEN,
	PO_CLOSE_SR_MODAL_CLOSE,
	PO_CLOSE_SR_DESCRIPTION,
	SR_TOGGLE_EDIT,
	INPUT_SERVICE_REQUEST_CHANGEVALUE,
	HANDLE_SR_BASE_PRICE,
	ORDER_DISC_PERCENT_SR_CHANGEVALUE,
	ITEM_GROSS_VAL_SR_CHANGEVALUE,
	ORDER_BASEPRICE_SR_CHANGEVALUE,
	ORDER_TAXTYPE_SR_CHANGEVALUE,
	ORDER_TAX_SR_CHANGEVALUE,
	SUBMIT_SR_EDIT_ORDER,
	VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE,
	VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE,
	PURCHASEREQUEST_SR_ROW_DATA,
	ITEM_TIME_LINE,
	SUBMIT_SR_EDIT_ORDER_SUCCESSFULL,
	SR_TOGGLE_EDIT_WITH_VALUE,
	PO_SR_HISTORY,
	PO_SR_HISTORY_SUCCESS,
	SR_SERVICE_INDENT_LIST_SUCCESS,
	SR_SERVICE_INDENT_LIST,
	SERVICE_REQUEST_NO_SELECT_SR_CHANGEVALUE,
	SERVICE_REQUEST_Location_SELECT_SR_CHANGEVALUE,
	SELECT_SERVICE_REQUEST_CHANGEVALUE,
	SR_SERVICE_REQUEST_ROW_DATA,
	SR_SERVICE_REQUEST_ROW_DATA_SUCCESS,
	SR_SERVICE_REQUEST_Q_VENDORS_LIST_SUCCESS,
	SR_SERVICE_REQUEST_Q_VENDORS_LIST,
	SR_SERVICE_REQUEST_ITEM_QTY_SR_CHANGEVALUE,
	RFQ_MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SR_MODEL_CLOSE,
	SR_SERVICE_REQUEST_ITEM_UNIT_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_PRICE_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_DISC_PERCENT_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_BASEPRICE_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_TAX_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_TAXTYPE_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_GROSS_VAL_SR_CHANGEVALUE,
	MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SUCCESS,
	MR_SR_SERVICE_REQUEST_ITEM_IMAGES,
	SR_SERVICE_REQUEST_QSR_ITEM_REMOVE,
	SR_SERVICE_REQUEST_QOUTATION_DATA_SUCCESS,
	SR_SERVICE_REQUEST_QOUTATION_DATA,
	SR_SERVICE_REQUEST_QUOTATION_ADD,
	WO_AUTHORIZATION_SUCCESS,
	WO_AUTHORIZATION,
	SET_MR_ERROR_MESSAGE,
} from "./actionTypes";
export const getPurchaseOrderList = (data) => {
	return {
		type: SR_PURCHASE_ORDER_LIST,
		payload: { data },
	};
};
export const PurchaseOrderListSuccessful = (response) => {
	return {
		type: SR_PURCHASE_ORDER_LIST_SUCCESS,
		payload: response,
	};
};
export const getServiceIndentList = (data) => {
	return {
		type: SR_SERVICE_INDENT_LIST,
		payload: { data },
	};
};
export const GetWoAuthorizationStatus = (data) => {
	return {
		type: WO_AUTHORIZATION,
		payload: { data },
	};
};
export const GetWoAuthorizationStatusSuccessful = (response) => {
	return {
		type: WO_AUTHORIZATION_SUCCESS,
		payload: response,
	};
};
export const getServiceIndentListSuccessful = (response) => {
	return {
		type: SR_SERVICE_INDENT_LIST_SUCCESS,
		payload: response,
	};
};

export const InputChangeValue = ({ key, value }) => {
	return {
		type: INPUT_SERVICE_REQUEST_CHANGEVALUE,
		payload: { key, value },
	};
};
export const rfqNoSelecteChangeValue = ({ key, label, key2, value }) => {
	return {
		type: SERVICE_REQUEST_NO_SELECT_SR_CHANGEVALUE,
		payload: { key, label, key2, value },
	};
};
export const rfqLocationSelecteChangeValue = ({ key, label, key2, value }) => {
	return {
		type: SERVICE_REQUEST_Location_SELECT_SR_CHANGEVALUE,
		payload: { key, label, key2, value },
	};
};

export const getMRItemImges = (rfqItemId) => {
	return {
		type: MR_SR_SERVICE_REQUEST_ITEM_IMAGES,
		payload: { rfqItemId },
	};
};
export const getMRItemImgesSuccessful = (response) => {
	return {
		type: MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SUCCESS,
		payload: response,
	};
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
	return {
		type: SELECT_SERVICE_REQUEST_CHANGEVALUE,
		payload: { key, label, key2, value },
	};
};
export const getQuotationtVendorsList = (rfqId) => {
	return {
		type: SR_SERVICE_REQUEST_Q_VENDORS_LIST,
		payload: { rfqId },
	};
};
export const QuotationtVendorsListSuccessful = (response) => {
	return {
		type: SR_SERVICE_REQUEST_Q_VENDORS_LIST_SUCCESS,
		payload: response,
	};
};

export const getServiceRequestRequestdata = (rfqId) => {
	return {
		type: SR_SERVICE_REQUEST_ROW_DATA,
		payload: { rfqId },
	};
};
export const getServiceRequestRequestdataSuccessful = (request) => {
	return {
		type: SR_SERVICE_REQUEST_ROW_DATA_SUCCESS,
		payload: request,
	};
};
export const itemQtyChangeValue = ({ key, value, item }) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_QTY_SR_CHANGEVALUE,
		payload: { key, value, item },
	};
};
export const itemUnitSelecteChangeValue = ({
	key,
	label,
	key2,
	value,
	item,
}) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_UNIT_SR_CHANGEVALUE,
		payload: { key, label, key2, value, item },
	};
};
export const itemPriceChangeValue = ({
	key,
	value,
	discount,
	discountpercent,
	item,
}) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_PRICE_SR_CHANGEVALUE,
		payload: { key, value, discount, discountpercent, item },
	};
};
export const itemDiscountPercentChangeValue = ({
	key,
	value,
	price,
	discount,
	item,
}) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_DISC_PERCENT_SR_CHANGEVALUE,
		payload: { key, value, price, discount, item },
	};
};

export const itemBasePriceChangeValue = ({
	key,
	value,
	price,
	discount,
	item,
}) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_BASEPRICE_SR_CHANGEVALUE,
		payload: { key, value, price, discount, item },
	};
};

export const itemTaxSelecteChangeValue = ({ id, name, tax, item }) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_TAX_SR_CHANGEVALUE,
		payload: { id, name, tax, item },
	};
};
export const itemTaxTypeSelecteChangeValue = ({
	key,
	label,
	key2,
	value,
	item,
}) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_TAXTYPE_SR_CHANGEVALUE,
		payload: { key, label, key2, value, item },
	};
};
export const itemGrossValChangeValue = (taxamt, net, item) => {
	return {
		type: SR_SERVICE_REQUEST_ITEM_GROSS_VAL_SR_CHANGEVALUE,
		payload: { taxamt, net, item },
	};
};
export const quotationAdd = (data, qoutId, history) => {
	return {
		type: SR_SERVICE_REQUEST_QUOTATION_ADD,
		payload: { data, qoutId, history },
	};
};
export const getQuotationData = (qId) => {
	return {
		type: SR_SERVICE_REQUEST_QOUTATION_DATA,
		payload: { qId },
	};
};
export const QuotationDatasuccessfull = (quotation) => {
	return {
		type: SR_SERVICE_REQUEST_QOUTATION_DATA_SUCCESS,
		payload: quotation,
	};
};
export const QItemRemove = (data) => {
	return {
		type: SR_SERVICE_REQUEST_QSR_ITEM_REMOVE,
		payload: data,
	};
};
export const toggleItemMenu = (id) => {
	return {
		type: SR_TOGGLE_ITEM_MENU,
		payload: id,
	};
};
export const getReqestRowDetails = (id, timeLine = false) => {
	return {
		type: PURCHASEREQUEST_SR_ROW_DATA,
		payload: { id, timeLine },
	};
};
export const getPurchaseOrderHistory = (params) => {
	console.log(params);
	return {
		type: PO_SR_HISTORY,
		payload: params,
	};
};
export const PurchaseOrderHistorySuccessful = (response) => {
	return {
		type: PO_SR_HISTORY_SUCCESS,
		payload: response.poitemshistory,
	};
};
export const SetParams = (params) => {
	return {
		type: SR_SET_PARAMS,
		payload: params,
	};
};
export const FilterChangeValue = ({ key, value }) => {
	return {
		type: FILTER_INPUT_SR_CHANGEVALUE,
		payload: { key, value },
	};
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
	return {
		type: FILTER_SELECT_SR_CHANGEVALUE,
		payload: { key, label, key2, value },
	};
};
export const getPurchaseOrderRowData = (poId, timeLine = false) => {
	return {
		type: SR_PURCHASE_ORDER_ROW_DATA,
		payload: { poId, timeLine },
	};
};
export const PurchaseOrderRowDataSuccessful = (response) => {
	return {
		type: SR_PURCHASE_ORDER_ROW_DATA_SUCCESS,
		payload: response,
	};
};
export const getMRCodeDetails = (ItemId) => {
	return {
		type: MR_SR_CODE_DETAILS,
		payload: { ItemId },
	};
};
export const getMRCodeDetailsSuccessful = (response) => {
	return {
		type: MR_SR_CODE_DETAILS_SUCCESS,
		payload: response,
	};
};
export const getPICodeDetails = (ItemId, qitemID) => {
	return {
		type: PI_SR_CODE_DETAILS,
		payload: { ItemId, qitemID },
	};
};
export const getPICodeDetailsSuccessful = (response) => {
	return {
		type: PI_SR_CODE_DETAILS_SUCCESS,
		payload: response,
	};
};
export const POIacknowledge_open = (data) => {
	return {
		type: SR_PO_ITEM_ACKNOWLEDGE_OPEN,
		payload: data,
	};
};
export const POIacknowledge_close = (POIacknowledge_Model) => {
	return {
		type: SR_PO_ITEM_ACKNOWLEDGE_CLOSE,
		payload: { POIacknowledge_Model },
	};
};

export const POClose_modal_open = () => {
	return {
		type: PO_CLOSE_SR_MODAL_OPEN,
	};
};
export const RFQMRItemImagesModel_close = () => {
	return {
		type: RFQ_MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SR_MODEL_CLOSE,
		payload: null,
	};
};
export const POClose_modal_close = () => {
	return {
		type: PO_CLOSE_SR_MODAL_CLOSE,
	};
};
export const ToggleEdit = (poItemId) => {
	return {
		type: SR_TOGGLE_EDIT,
		payload: poItemId,
	};
};
export const ToggleEditWithValue = (value) => {
	return {
		type: SR_TOGGLE_EDIT_WITH_VALUE,
	};
};

export const POAcknowledgeInputChangeValue = ({ key, value }) => {
	return {
		type: SR_PO_ITEM_INPUT_SR_CHANGEVALUE,
		payload: { key, value },
	};
};

export const POCancelDescription = ({ key, value }) => {
	return {
		type: PO_CLOSE_SR_DESCRIPTION,
		payload: { key, value },
	};
};
export const SubmitPOiacknowledge = (data) => {
	return {
		type: SR_PO_ITEM_ACKNOWLEDGE,
		payload: { data },
	};
};

export const SubmitEditOrder = (order, id) => {
	const purchaseId = id;
	const reformatDate = (dateStr) => {
		const [day, month, year] = dateStr.split("-");
		return `${year}-${month}-${day}`;
	};

	const data = {
		comparequotation_id: order.comparequotation,
		location_id: order.location.id,
		sublocation_id: order.sublocation ? order.sublocation.id : null,
		requestforquotation_id: order.requestforquotation,
		quotation_id: order.quotation,
		vendor_id: order.vendor.id,
		deliverydate: order.deliverydate
			? reformatDate(order.deliverydate)
			: null,
		cost_center_type: order.cost_center_type,
		purchase_type: order.purchase_type,
		sublocation_id: order.sublocation?.id,
		poitems: order?.poitems?.map((item) => ({
			id: item.id,
			product_id: item.product.id,
			unit_id: item.unit.id,
			tax_id: item.tax.id,
			qitem_id: item.qitem,
			cqitem_id: item.cqitem,
			qty: item.qty,
			baseprice: item.baseprice,
			price: parseFloat(item.price).toFixed(2),
			taxamount: parseFloat(item.taxamount).toFixed(2),
			gross: parseFloat(item.gross).toFixed(2),
			discount: item.discount,
			discountpercent: item.discountpercent,
			description: item.description,
			date: item.date,
			make: item.make,
		})),
	};
	return {
		type: SUBMIT_SR_EDIT_ORDER,
		payload: { data, purchaseId },
	};
};
export const SubmitEditOrderSuccessfull = () => {
	return {
		type: SUBMIT_SR_EDIT_ORDER_SUCCESSFULL,
	};
};
export const listlayout = (layout) => {
	return {
		type: SR_LIST_LAYOUT,
		payload: layout,
	};
};
export const FiltersShowRightSidebar = () => {
	return {
		type: FILTERS_SHOW_SRQ_RIGHT_SIDEBAR,
		payload: null,
	};
};
export const viewLogShowRightSidebarPurchase = (purchaseId) => {
	return {
		type: VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE,
		payload: { purchaseId },
	};
};
export const viewLogHideRightSidebarPurchase = (purchaseId) => {
	return {
		type: VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE,
		payload: { purchaseId },
	};
};

export const FiltershideRightSidebar = () => ({
	type: FILTERS_HIDE_SR_RIGHT_SIDEBAR,
	payload: null,
});
export const FilterClear = () => {
	return {
		type: CLEAR_FILTER,
		payload: null,
	};
};
export const getPDFDownload = (POId) => {
	return {
		type: SR_PDF_DOWNNLOAD,
		payload: { POId },
	};
};
export const PurchaseOrderClose = (id, description) => {
	return {
		type: SR_PURCHASE_ORDER_CLOSE,
		payload: { id, description },
	};
};
export const apiError = (error) => {
	return {
		type: API_ERROR,
		payload: error,
	};
};

export const PoFoucsPost = (id) => {
	return {
		type: SR_PURCHASE_ORDER_FOUCS_POST,
		payload: { id },
	};
};
export const handleBasePrice = (data) => {
	return {
		type: HANDLE_SR_BASE_PRICE,
		payload: { data },
	};
};

export const orderDiscountPercentChangeValue = ({
	key,
	value,
	price,
	discount,
	item,
}) => {
	return {
		type: ORDER_DISC_PERCENT_SR_CHANGEVALUE,
		payload: { key, value, price, discount, item },
	};
};
export const orderGrossValChangeValue = (taxamount, net, item) => {
	return {
		type: ITEM_GROSS_VAL_SR_CHANGEVALUE,
		payload: { taxamount, net, item },
	};
};
export const orderBasePriceChangeValue = ({
	key,
	value,
	price,
	discount,
	item,
}) => {
	return {
		type: ORDER_BASEPRICE_SR_CHANGEVALUE,
		payload: { key, value, price, discount, item },
	};
};
export const orderTaxTypeSelecteChangeValue = ({
	key,
	label,
	key2,
	value,
	item,
}) => {
	return {
		type: ORDER_TAXTYPE_SR_CHANGEVALUE,
		payload: { key, label, key2, value, item },
	};
};

export const orderTaxSelecteChangeValue = ({ id, name, tax, item }) => {
	return {
		type: ORDER_TAX_SR_CHANGEVALUE,
		payload: { id, name, tax, item },
	};
};

export const setMRErrorMessage = (message) => ({
	type: SET_MR_ERROR_MESSAGE,
	payload: message,
});
